import { render } from "./FormTextbox.vue?vue&type=template&id=f0c73a72"
import script from "./FormTextbox.vue?vue&type=script&lang=js"
export * from "./FormTextbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__